import React from "react";
import { Grid, TextField } from "@mui/material";

const Measurements = ({ formData, handleInputChange }) => {
  return (
    <>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Tour de Poignet (cm)"
          name="tourDePoignet"
          type="number"
          value={formData.tourDePoignet}
          onChange={handleInputChange}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <TextField
          label="Tour de Cheville (cm)"
          name="tourDeCheville"
          type="number"
          value={formData.tourDeCheville}
          onChange={handleInputChange}
          fullWidth
        />
      </Grid>
    </>
  );
};

export default Measurements;
